export default __webpack_public_path__ + "a52534ecb4754a499052a1c077d817c7.png";